import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';

import * as am5map from "@amcharts/amcharts5/map";
import * as am5percent from "@amcharts/amcharts5/percent";
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";

import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";

@Component({
  selector: 'app-super-course-attendance',
  templateUrl: './super-course-attendance.component.html',
  styleUrls: ['./super-course-attendance.component.scss']
})
export class SuperCourseAttendanceComponent implements OnInit {

  MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  mentor_data: any;
  no_of_student: any;
  student_list: any = [];
  student_lists: any = [];
  CM_course_image: any;



  onItemSelect(item: any) {
    console.log('onItemSelect', item);
    this.student_lists.push(item);
  }
  onItemDeSelect(item: any) {
    console.log('onItemDeSelect', item);
    this.student_lists = this.student_lists.map((e) => {
      if (e! == item) {
        return e;
      }
    })
  }
  onSelectAll(items: any) {
    console.log('onSelectAll', items);
    this.student_lists = items;
  }
  onUnSelectAll() {
    console.log('onUnSelectAll fires');
    this.student_lists = [];
  }


  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe) {
    this.createmeetingform= this.fb.group({
      course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
      status:[''],
      image:['']
    });
    this.editformInitialize('false');
    this.district = JSON.parse(localStorage.getItem('user_district'));

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  errorMessage:boolean;
  ngOnInit():void{
    // const userCategory = localStorage.getItem('category');
    // console.log(userCategory);
    // // this.createmeetingform.get('district').value(this.userDistrict);
    // // this.createmeetingform.get('constituency').value(this.userConstituency);
    //   console.log(this.userDistrict,this.userConstituency,this.ApiService.user_details,"djnjdn");
    // // Remove double quotation marks from userCategory
    // const cleanedUserCategory = userCategory.replace(/"/g, '');
    // console.log(cleanedUserCategory);
    // if (cleanedUserCategory === 'OB') {
    //   console.log('Inside if block');
    //   this.isButtonDisabled = true;
    // } else {
    //   console.log('Inside else block');
    //   this.isButtonDisabled = false;
    // }
    // this.date = new Date();

      this.ApiService.courseAssignedToMentor(this.users.first_name).subscribe((data: any) => {
       console.log(data, "sknsdnjs");
       this.mentor_data = data;  
     })
    
    this.ApiService.getOBDetailsForDistrictOccurance().subscribe((data) => {
      this.ob_data = data;
    })
    
// document.write(today);
    this.customers=[];
    this.showSpinner();
   
    this.ApiService.SuperCourseAttendance().subscribe((data: any) => {
      if (data.length === 0) {
          this.errorMessage = true;
      } else {
          this.enableButton = false; // Initially disable the button
          let currentDate = new Date(); // Get the current date
        
          // Check if any customer has a start date in the past
          if (data.some(customer => {
              let startDate = new Date(customer.start_date + 'T' + customer.start_time); // Combine start_date and start_time strings into a single Date object
              return currentDate.getTime() >= startDate.getTime(); // Return true if the start date is in the past
          })) {
              this.enableButton = true; // Enable the button if any customer has a start date in the past
          }
      }
      this.customers = data;
      this.tableshow = true;
      console.log(this.customers);
  });
  
    
     this.ApiService.getCourses().subscribe((data: any) => {
       console.log(data, "s,mfdnsd");
       this.courses = data;
      })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [2,'asc']
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  this.da_district=localStorage.getItem('user_district');
 

  }
  enableButton:Boolean;
  isStartDateInTheFuture(item: any): boolean {
    let startDate = new Date(item.start_date + 'T' + item.start_time); // Combine start_date and start_time strings into a single Date object
    let currentDate = new Date(); // Get the current date
    return currentDate.getTime() < startDate.getTime(); // Return true if the start date is in the future
  }

  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('district').setValue(this.userDistrict);
    this.createmeetingform.get('constituency').setValue(this.userConstituency);
    this.createmeetingform.get('user_id').setValue(this.userId);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  customers:any=[];
  

  postdata(angForm1 : any) //angForm1
    {
    console.log(angForm1.value);

          this.ApiService.createDistrictOccurance(angForm1.value).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
                    setTimeout(function () {
                      alert("Course District Occurance has been created!");
                      window.location.reload();
                    }, 100)
                },
              
              error => {
                console.log(error);
              });
          }
    
 
    delete_CM(id : any){
      console.log(id)
      if(confirm("Are you sure want to cancel this District Occurance ?")) {
        console.log("Implement delete functionality here");
          this.ApiService.deleteDistrictOccurance(id)
          .pipe()
          .subscribe(
          data => {
              window.location.reload();
              alert("Course District Occurance has been deleted Successfully!")
          },

          error => {
              console.log(error);
          });

  }
}

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
  }
  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;
  student_names: any;
  uploadFiles: any = [];
  CM_course_id: any;
  image1: any;
  image2: any;
  image3: any;
  image4: any;
  image5: any;
  attendances: any;

   selectFiles(event:any) {
    console.log(event.target.files[0].name, "dnjsndk");
    if (event.target.files[0].size < 60000) {
    if (this.uploadFiles.length < 5) {
      $('#title').css('display', 'block');
      this.spinner = true;
      
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles.push(da);
        this.spinner = false;
        $('#list').append(`<label class="form-label">${event.target.files[0].name}</label><br/>`)
      })
    } else {
      alert('The file upload should be 5 or less than 5');
    }
    } else {
      alert('The size should be less than 60kb');
      $('#file').val('');
    }
    
  }



  editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a, editbutton);
    
    
       this.ApiService.getStudentGraphStudent(a.course_id).subscribe((d:any) => {
      console.log(d, "dsndsnsj");

      /* Chart code */

// Create root element
// https://www.amcharts.com/docs/v5/getting-started/#Root_element
let root = am5.Root.new("graphDiv2");


let myTheme = am5.Theme.new(root);

myTheme.rule("Grid", ["base"]).setAll({
  strokeOpacity: 0.1
});


// Set themes
// https://www.amcharts.com/docs/v5/concepts/themes/
root.setThemes([
  am5themes_Animated.new(root),
  myTheme
]);


// Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
let chart = root.container.children.push(
  am5xy.XYChart.new(root, {
    panX: false,
    panY: false,
    wheelX: "none",
    wheelY: "none",
    paddingLeft: 0
  })
);


// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
let yRenderer = am5xy.AxisRendererY.new(root, {
  minGridDistance: 30
});
yRenderer.grid.template.set("location", 1);

let yAxis = chart.yAxes.push(
  am5xy.CategoryAxis.new(root, {
    maxDeviation: 0,
    categoryField: "name",
    renderer: yRenderer
  })
);

let xAxis = chart.xAxes.push(
  am5xy.ValueAxis.new(root, {
    maxDeviation: 0,
    min: 0,
    renderer: am5xy.AxisRendererX.new(root, {
      visible: true,
      strokeOpacity: 0.1,
      minGridDistance: 80
    })
  })
);


// Create series
// https://www.amcharts.com/docs/v5/charts/xy-chart/series/
let series = chart.series.push(
  am5xy.ColumnSeries.new(root, {
    name: "Series 1",
    xAxis: xAxis,
    yAxis: yAxis,
    valueXField: "value",
    sequencedInterpolation: true,
    categoryYField: "name"
  })
);

let columnTemplate = series.columns.template;

columnTemplate.setAll({
  draggable: true,
  cursorOverStyle: "pointer",
  tooltipText: "drag to rearrange",
  cornerRadiusBR: 10,
  cornerRadiusTR: 10,
  strokeOpacity: 0
});
columnTemplate.adapters.add("fill", (fill, target) => {
  return chart.get("colors").getIndex(series.columns.indexOf(target));
});

columnTemplate.adapters.add("stroke", (stroke, target) => {
  return chart.get("colors").getIndex(series.columns.indexOf(target));
});

columnTemplate.events.on("dragstop", () => {
  sortCategoryAxis();
});

// Get series item by category
      function getSeriesItem(category: any) {
        let dataItem: any;
  for (var i = 0; i < series.dataItems.length; i++) {
     dataItem = series.dataItems[i];
    if (dataItem.get("categoryY") == category) {
      return dataItem;
    }
  }
  
}


// Axis sorting
function sortCategoryAxis() {
  // Sort by value
  series.dataItems.sort(function (x, y) {
    return y.get("graphics").y() - x.get("graphics").y();
  });

  let easing = am5.ease.out(am5.ease.cubic);

  // Go through each axis item
  am5.array.each(yAxis.dataItems, function (dataItem) {
    // get corresponding series item
    let seriesDataItem = getSeriesItem(dataItem.get("category"));

    if (seriesDataItem) {
      // get index of series data item
      let index = series.dataItems.indexOf(seriesDataItem);

      let column = seriesDataItem.get("graphics");

      // position after sorting
      let fy =
        yRenderer.positionToCoordinate(yAxis.indexToPosition(index)) -
        column.height() / 2;

      // set index to be the same as series data item index
      if (index != dataItem.get("index")) {
        dataItem.set("index", index);

        // current position
        let x = column.x();
        let y = column.y();

        column.set("dy", -(fy - y));
        column.set("dx", x);

        column.animate({ key: "dy", to: 0, duration: 600, easing: easing });
        column.animate({ key: "dx", to: 0, duration: 600, easing: easing });
      } else {
        column.animate({ key: "y", to: fy, duration: 600, easing: easing });
        column.animate({ key: "x", to: 0, duration: 600, easing: easing });
      }
    }
  });

  // Sort axis items by index.
  // This changes the order instantly, but as dx and dy is set and animated,
  // they keep in the same places and then animate to true positions.
  yAxis.dataItems.sort(function (x, y) {
    return x.get("index") - y.get("index");
  });
}




yAxis.data.setAll(d);
series.data.setAll(d);


// Make stuff animate on load
// https://www.amcharts.com/docs/v5/concepts/animations/
series.appear(1000);
chart.appear(1000, 100);



   
       })
    
       this.ApiService.getMentorGraph(a.course_id).subscribe((d:any) => {
      console.log(d, "dsndsnsj");

      /* Chart code */

// Create root element
// https://www.amcharts.com/docs/v5/getting-started/#Root_element
let root = am5.Root.new("graphDiv");


let myTheme = am5.Theme.new(root);

myTheme.rule("Grid", ["base"]).setAll({
  strokeOpacity: 0.1
});


// Set themes
// https://www.amcharts.com/docs/v5/concepts/themes/
root.setThemes([
  am5themes_Animated.new(root),
  myTheme
]);


// Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
let chart = root.container.children.push(
  am5xy.XYChart.new(root, {
    panX: false,
    panY: false,
    wheelX: "none",
    wheelY: "none",
    paddingLeft: 0
  })
);


// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
let yRenderer = am5xy.AxisRendererY.new(root, {
  minGridDistance: 30
});
yRenderer.grid.template.set("location", 1);

let yAxis = chart.yAxes.push(
  am5xy.CategoryAxis.new(root, {
    maxDeviation: 0,
    categoryField: "name",
    renderer: yRenderer
  })
);

let xAxis = chart.xAxes.push(
  am5xy.ValueAxis.new(root, {
    maxDeviation: 0,
    min: 0,
    renderer: am5xy.AxisRendererX.new(root, {
      visible: true,
      strokeOpacity: 0.1,
      minGridDistance: 80
    })
  })
);


// Create series
// https://www.amcharts.com/docs/v5/charts/xy-chart/series/
let series = chart.series.push(
  am5xy.ColumnSeries.new(root, {
    name: "Series 1",
    xAxis: xAxis,
    yAxis: yAxis,
    valueXField: "value",
    sequencedInterpolation: true,
    categoryYField: "name"
  })
);

let columnTemplate = series.columns.template;

columnTemplate.setAll({
  draggable: true,
  cursorOverStyle: "pointer",
  tooltipText: "drag to rearrange",
  cornerRadiusBR: 10,
  cornerRadiusTR: 10,
  strokeOpacity: 0
});
columnTemplate.adapters.add("fill", (fill, target) => {
  return chart.get("colors").getIndex(series.columns.indexOf(target));
});

columnTemplate.adapters.add("stroke", (stroke, target) => {
  return chart.get("colors").getIndex(series.columns.indexOf(target));
});

columnTemplate.events.on("dragstop", () => {
  sortCategoryAxis();
});

// Get series item by category
      function getSeriesItem(category: any) {
        let dataItem: any;
  for (var i = 0; i < series.dataItems.length; i++) {
     dataItem = series.dataItems[i];
    if (dataItem.get("categoryY") == category) {
      return dataItem;
    }
  }
  
}


// Axis sorting
function sortCategoryAxis() {
  // Sort by value
  series.dataItems.sort(function (x, y) {
    return y.get("graphics").y() - x.get("graphics").y();
  });

  let easing = am5.ease.out(am5.ease.cubic);

  // Go through each axis item
  am5.array.each(yAxis.dataItems, function (dataItem) {
    // get corresponding series item
    let seriesDataItem = getSeriesItem(dataItem.get("category"));

    if (seriesDataItem) {
      // get index of series data item
      let index = series.dataItems.indexOf(seriesDataItem);

      let column = seriesDataItem.get("graphics");

      // position after sorting
      let fy =
        yRenderer.positionToCoordinate(yAxis.indexToPosition(index)) -
        column.height() / 2;

      // set index to be the same as series data item index
      if (index != dataItem.get("index")) {
        dataItem.set("index", index);

        // current position
        let x = column.x();
        let y = column.y();

        column.set("dy", -(fy - y));
        column.set("dx", x);

        column.animate({ key: "dy", to: 0, duration: 600, easing: easing });
        column.animate({ key: "dx", to: 0, duration: 600, easing: easing });
      } else {
        column.animate({ key: "y", to: fy, duration: 600, easing: easing });
        column.animate({ key: "x", to: 0, duration: 600, easing: easing });
      }
    }
  });

  // Sort axis items by index.
  // This changes the order instantly, but as dx and dy is set and animated,
  // they keep in the same places and then animate to true positions.
  yAxis.dataItems.sort(function (x, y) {
    return x.get("index") - y.get("index");
  });
}




yAxis.data.setAll(d);
series.data.setAll(d);


// Make stuff animate on load
// https://www.amcharts.com/docs/v5/concepts/animations/
series.appear(1000);
chart.appear(1000, 100);



   
     })
    //console.log(a.date)
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
      this.CM_course_name=a.course_name;
          this.CM_district=a.district;
          this.CM_constituency=a.constituency;
    this.CM_startDate = this.datepipe.transform( a.start_date, 'dd-MM-yyyy');
    this.CM_organizer = a.organizer;
          this.CM_endDate=this.datepipe.transform( a.end_date, 'dd-MM-yyyy');
          this.CM_startTime=a.start_time;
          this.CM_endTime=a.end_time;
          this.CM_volunteer1=a.volunteer1;
    this.CM_volunteer2 = a.volunteer2;
    this.CM_location = a.location;
    this.CM_status = a.status;
    this.CM_comments = a.comments;
    this.CM_course_id = a.course_id;
    this.CM_id = a.id;
    this.attendances = a.students_attendance;
    this.CM_course_image=a.image;
    this.image1 = a.image1;
    this.image2 = a.image2;
    this.image3 = a.image3;
    this.image4 = a.image4;
    this.image5 = a.image5;
    this.editmeetingform.get('comments').setValue(a.comments);
    this.editmeetingform.get('course_name').setValue(a.course_name);
    this.editmeetingform.get('organizer').setValue(a.organizer);
    this.editmeetingform.get('day_of_course').setValue(a.date_of_course);
    this.editmeetingform.get('date_of_course').setValue(this.datepipe.transform(a.day_of_course, 'dd-MM-yyyy'));
    this.editmeetingform.get('attendances').setValue(a.students_attendance);
      
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

  }
  
  

          editformInitialize(a){
            this.editmeetingform= this.fb.group({
           course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
              status: [''],
              day_of_course: [''],
              date_of_course: [''],
              no_of_students: [''],
              photos: [''],
              image:[]
             
          });
          }
        
          updatedata(updateform,id){
            console.log(updateform,id);  
            this.spinner = true;
            let values = updateform.value;
            values['images'] = this.uploadFiles;
            values['course_id'] = this.CM_course_id;
            values['students_attendance'] = this.student_lists;
            console.log(values, "sdjndsn");
            this.ApiService.CourseAttendance(values).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
                    setTimeout(function () {
                                  Swal.fire({
  title: "Your Course Attendance created Successfully!",
   icon: "success",
                  confirmButtonText: "Okay",
   confirmButtonColor: 'green',

}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {
    window.location.reload();
  } 
});
                    }, 100)
                },
              
              error => {
                console.log(error);
              });
          }

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}
student_Attendence:any=[];
studentAttendance(student_attenence:any){
    console.log(student_attenence);
    this.student_Attendence=student_attenence.attendances;
    console.log(this.student_Attendence.length);
  this.tableshow=true;
  
}
}
